import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { navigationViews, UpdateService } from '../../../services/update.service';

@Component({
	moduleId: module.id,
	selector: 'mobile-menu-public',
	templateUrl: 'mobile-menu-public.html',
	styleUrls: ['mobile-menu-public.scss']
})

export class MobileMenuPublicComponent implements OnInit, OnDestroy {
	public visible = false;

	public NAVIGATION_VIEWS = navigationViews;
	public currentPage: navigationViews = null;
	private _subscriptions$: Subject<boolean>;

	constructor(private router: Router,
		private _dialog: MatDialog,
		private _updateService: UpdateService) { }

	ngOnInit() {
		this._subscriptions$ = new Subject();

		this._updateService.currentPage$
			.pipe(takeUntil(this._subscriptions$)).subscribe((view: navigationViews) => {

			this.currentPage = view;
		});
	}

	ngOnDestroy(): void {
		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	open(): void {
		this.visible = true;
	}

	close(): void {
		this.visible = false;
	}

	openDonationLink(): void {

	}

	openDiscordLink(): void {

	}

	navigateToMyRanches(): void {
		this.close();
		this.router.navigate(['MyDashboard']);
	}

	navigateToAdministration(): void {
		this.close();
		this.router.navigate(['Administration']);
	}

	public clickOutside(e: MouseEvent): void {
		let classList: DOMTokenList;

		if (!e || !e.target) {
			return;
		}

		classList = (e != null && e.target != null) ? (e.target as HTMLElement).classList : null;

		if (classList.contains('bk-header__menu-icon') || classList.contains('fa-bars')) {
			return;
		}

		if (this.visible) {
			this.visible = false;
		}
	}
}
